import React from 'react'
import './App.css'

import { ConfigProvider, theme } from 'antd'

import SiteLayout from './components/SiteLayout'

const App = () => {
  return (
    <ConfigProvider
      theme={{
        algorithm: theme.darkAlgorithm,
        token: {
          colorPrimary: '#3b82f6',
          colorBgBase: '#0b1020',
          colorBgContainer: '#11161d',
          colorBgElevated: '#18202a',
          colorBorder: 'rgba(255,255,255,0.08)',
          colorText: '#e6edf3',
          colorTextSecondary: '#8b98a5',
          borderRadius: 12
        }
      }}
    >
      <div style={{ height: '100vh' }}>
        <SiteLayout />
      </div>
    </ConfigProvider>
  )
}

export default App
